// extracted by mini-css-extract-plugin
module.exports = {"root":"_e06615"};